// <em> Italic 대체, <li> 내부 <p> 제거
export const sanitizeContent = (rawContent: string): string => {
  // <em> 태그를 <p>로 대체하고, <li> 내의 <p> 태그를 제거
  const withoutPInLi = rawContent
    .replace(/<em>/g, "<p>")
    .replace(/<\/em>/g, "</p>")
    .replace(/<li>\s*<p>/g, "<li><p>")
    .replace(/<\/p>\s*<\/li>/g, "</p></li>")
    .replace(/<li>(.*?)<\/li>/g, (match, p1) => {
      if (p1.includes("<p>")) {
        // 각 <p>를 줄바꿈 포함 텍스트로 변환
        const cleaned = p1.replace(
          /<p>(.*?)<\/p>/g,
          (_: string, content: string) => `${content}<br/>`,
        );
        return `<li>${cleaned}</li>`;
      }
      return match;
    });

  // 리스트 점이 텍스트와 같은 라인에 오도록 스타일 수정
  const withoutParagraphSpacing = withoutPInLi.replace(
    /<ul>([\s\S]*?)<\/ul>/g, // 이 부분에서 [\s\S]를 사용하여 개행 문자를 포함하도록 수정
    (match) =>
      match.replace(/<li>/g, '<li style="list-style-position: inside;">'),
  );

  // 인용구 내부의 텍스트 색상 설정
  const withStyledBlockquoteP = withoutParagraphSpacing.replace(
    /<blockquote>([\s\S]*?)<\/blockquote>/g,
    (match) => match.replace(/<p>/g, '<p style="color:#999">'),
  );

  // 취소선 설정
  const withStyledHr = withStyledBlockquoteP.replace(
    /<hr\s*\/?>/g,
    '<div style="background-color: #eee; height: 1px; margin-top: 16px; margin-bottom: 16px;"/>',
  );

  // del이 적용된 p 새로 생성
  const withStrikethrough = withStyledHr.replace(
    /<del>(.*?)<\/del>/g,
    '<p style="text-decoration: line-through; color: #999;">$1</p>',
  );

  // 테이블 헤더 내부 p 색상 설정
  const withStyledThP = withStrikethrough.replace(
    /<th>([\s\S]*?)<\/th>/g,
    (match) => match.replace(/<p>/g, '<p style="color:#fff;">'),
  );

  // CheckBox 설정
  const withCheckboxInputs = withStyledThP
    // 체크된 항목
    .replace(
      /<li class="task-list-item checked" data-task="true" data-task-checked="true">([\s\S]*?)<\/li>/g,
      (_match, content) => {
        const innerText = content.replace(/<\/?p>/g, "").trim();
        return `<li style="list-style: none; padding-left: 16px;"><p>☑️ ${innerText}</p></li>`;
      },
    )
    // 체크되지 않은 항목
    .replace(
      /<li class="task-list-item" data-task="true">([\s\S]*?)<\/li>/g,
      (_match, content) => {
        const innerText = content.replace(/<\/?p>/g, "").trim();
        return `<li style="list-style: none; padding-left: 16px;"><p>◻️ ${innerText}</p></li>`;
      },
    );

  return withCheckboxInputs;
};
